import React, { Component } from 'react';
import { Button } from 'reactstrap';
import _ from 'lodash';
import PageContainer from 'components/PageContainer';
import { get } from 'helpers/requests';
import { API, BASE_URL, SEARCH_DELAY_MS } from 'CONST';
import LdapUsersTable from './LdapUsersTable';
import { applyFilters, buildFilterOptions } from './ldapFilters';

const PAGE_SIZE = 20;

class LdapUsersList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allUsers: [],
      filterOptions: {},
      data: [],
      count: 0,
      pages: 1,
      loading: true,
      error: false,
    };
    this.filtering = false;
    this.lastTableState = { page: 0, filtered: [] };

    this.onFilteredChange = this.onFilteredChange.bind(this);
    this.fetchStrategy = this.fetchStrategy.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.fetchLdapUsers = this.fetchLdapUsers.bind(this);
    this.fetchDataWithDebounce = _.debounce(this.fetchData, SEARCH_DELAY_MS);
  }

  componentDidMount() {
    this.fetchLdapUsers();
  }

  onFilteredChange() {
    this.filtering = true;
  }

  fetchStrategy(tableState) {
    if (this.filtering) {
      return this.fetchDataWithDebounce(tableState);
    }
    return this.fetchData(tableState);
  }

  fetchLdapUsers() {
    this.setState({ loading: true, error: false });
    get(`${BASE_URL}${API.ldapUsers}`)
      .then((allUsers) => {
        this.setState(
          { allUsers, filterOptions: buildFilterOptions(allUsers) },
          () => this.fetchData(this.lastTableState),
        );
      })
      .catch(() => {
        this.setState({ loading: false, error: true });
      });
  }

  fetchData(state) {
    const { allUsers } = this.state;
    this.filtering = false;
    this.lastTableState = state;

    const filtered = applyFilters(allUsers, state.filtered);

    const count = filtered.length;
    const pages = Math.max(Math.ceil(count / PAGE_SIZE), 1);
    const page = state.page || 0;
    const data = filtered.slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);

    this.setState({ data, count, pages, loading: false });
  }

  render() {
    const {
      data, count, pages, loading, error, filterOptions,
    } = this.state;
    return (
      <PageContainer breadcrumbs={[{ name: 'ORSAN' }, { name: 'USUARIOS LDAP' }]}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
          <Button
            style={{
              backgroundColor: 'var(--orsan-blue)',
              border: 'var(--orsan-blue)',
            }}
            onClick={this.fetchLdapUsers}
            disabled={loading}
          >
            Actualizar
          </Button>
        </div>
        {error && (
          <p className="text-danger">
            No se pudo conectar con el servicio LDAP. Intente actualizar nuevamente.
          </p>
        )}
        <LdapUsersTable
          count={count}
          data={data}
          filterOptions={filterOptions}
          loading={loading}
          pages={pages}
          onFetchData={this.fetchStrategy}
          onFilteredChange={this.onFilteredChange}
        />
      </PageContainer>
    );
  }
}

export default LdapUsersList;
